import { useEffect, useRef } from "react";
import { MessageCircle, Sparkles } from "lucide-react";
import { useSiteUi } from "@/context/SiteUiContext";
import { waLink } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export function useWaNumber() {
  return useLang().whatsappNumber;
}

export default function WhatsAppFab() {
  const num = useWaNumber();
  const { t } = useLang();
  const { chatOpen, setChatOpen, modalCount, mobile, editing } = useSiteUi();
  const text = t("wa_general");
  const dockRef = useRef(null);
  const visible = mobile && !chatOpen && modalCount === 0 && !editing;
  useEffect(() => {
    if (!visible || !dockRef.current) return undefined;
    const observer = new ResizeObserver(([entry]) => document.documentElement.style.setProperty("--ptg-help-space", `${entry.target.getBoundingClientRect().height + 24}px`));
    observer.observe(dockRef.current);
    return () => observer.disconnect();
  }, [visible]);
  if (chatOpen || modalCount > 0 || (mobile && editing)) return null;
  if (mobile) return <div ref={dockRef} data-testid="mobile-help-dock" aria-label={t("mobile_help")} className="mobile-help-dock">
    <button data-testid="mobile-uda-ai-btn" onClick={() => setChatOpen(true)} className="flex min-h-12 min-w-0 items-center justify-center gap-2 rounded-full bg-[#064E3B] px-3 py-2 text-sm font-bold text-white transition-colors hover:bg-[#047857]"><Sparkles className="h-5 w-5 shrink-0 text-amber-300" /><span>Uda AI</span></button>
    {num && <a href={waLink(num, text)} target="_blank" rel="noreferrer" data-testid="mobile-whatsapp-btn" className="flex min-h-12 min-w-0 items-center justify-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm font-bold text-[#064E3B] transition-colors hover:bg-emerald-100"><MessageCircle className="h-5 w-5 shrink-0" /><span>WhatsApp</span></a>}
  </div>;
  if (!num) return null;
  return (
    <a href={waLink(num, text)} target="_blank" rel="noreferrer" data-testid="floating-whatsapp-btn"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] py-3 pl-3 pr-5 text-sm font-bold text-white shadow-xl shadow-emerald-900/20 transition-transform hover:scale-105">
      <span className="relative flex h-8 w-8 items-center justify-center rounded-full bg-white/20">
        <MessageCircle className="h-5 w-5" />
        <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full bg-white animate-pulse" />
      </span>
      <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
}
